// =====================================================================
// Tier graphics
// =====================================================================

export const graphicPro = (
    <svg width="120" height="90" viewBox="0 0 120 90" fill="none" aria-hidden="true">
        {/* L0 → L1 */}
        <line x1="60" y1="14" x2="30" y2="32" stroke="currentColor" strokeWidth="2"/>
        <line x1="60" y1="14" x2="90" y2="32" stroke="currentColor" strokeWidth="2"/>
        {/* L1 → L2 */}
        <line x1="30" y1="36" x2="14" y2="55" stroke="currentColor" strokeWidth="1.8"/>
        <line x1="30" y1="36" x2="46" y2="55" stroke="currentColor" strokeWidth="1.8"/>
        <line x1="90" y1="36" x2="74" y2="55" stroke="currentColor" strokeWidth="1.8"/>
        <line x1="90" y1="36" x2="106" y2="55" stroke="currentColor" strokeWidth="1.8"/>
        {/* L2 → L3 (leaves) */}
        <line x1="14" y1="58" x2="6" y2="78" stroke="currentColor" strokeWidth="1.5"/>
        <line x1="14" y1="58" x2="22" y2="78" stroke="currentColor" strokeWidth="1.5"/>
        <line x1="46" y1="58" x2="38" y2="78" stroke="currentColor" strokeWidth="1.5"/>
        <line x1="46" y1="58" x2="54" y2="78" stroke="currentColor" strokeWidth="1.5"/>
        <line x1="74" y1="58" x2="66" y2="78" stroke="currentColor" strokeWidth="1.5"/>
        <line x1="74" y1="58" x2="82" y2="78" stroke="currentColor" strokeWidth="1.5"/>
        <line x1="106" y1="58" x2="98" y2="78" stroke="currentColor" strokeWidth="1.5"/>
        <line x1="106" y1="58" x2="114" y2="78" stroke="currentColor" strokeWidth="1.5"/>
        {/* Nodes (size decreases with depth) */}
        <circle cx="60" cy="12" r="6" fill="currentColor"/>
        <circle cx="30" cy="34" r="5" fill="currentColor"/>
        <circle cx="90" cy="34" r="5" fill="currentColor"/>
        <circle cx="14" cy="56" r="4" fill="currentColor"/>
        <circle cx="46" cy="56" r="4" fill="currentColor"/>
        <circle cx="74" cy="56" r="4" fill="currentColor"/>
        <circle cx="106" cy="56" r="4" fill="currentColor"/>
        <circle cx="6" cy="80" r="3" fill="currentColor"/>
        <circle cx="22" cy="80" r="3" fill="currentColor"/>
        <circle cx="38" cy="80" r="3" fill="currentColor"/>
        <circle cx="54" cy="80" r="3" fill="currentColor"/>
        <circle cx="66" cy="80" r="3" fill="currentColor"/>
        <circle cx="82" cy="80" r="3" fill="currentColor"/>
        <circle cx="98" cy="80" r="3" fill="currentColor"/>
        <circle cx="114" cy="80" r="3" fill="currentColor"/>
    </svg>
)

export const graphicFree = (
    <svg width="120" height="90" viewBox="0 0 120 90" fill="none" aria-hidden="true">
        {/* L0 → L1 */}
        <line x1="60" y1="22" x2="30" y2="50" stroke="currentColor" strokeWidth="2"/>
        <line x1="60" y1="22" x2="90" y2="50" stroke="currentColor" strokeWidth="2"/>
        {/* L1 → L2 */}
        <line x1="30" y1="54" x2="14" y2="78" stroke="currentColor" strokeWidth="1.8"/>
        <line x1="30" y1="54" x2="46" y2="78" stroke="currentColor" strokeWidth="1.8"/>
        <line x1="90" y1="54" x2="74" y2="78" stroke="currentColor" strokeWidth="1.8"/>
        <line x1="90" y1="54" x2="106" y2="78" stroke="currentColor" strokeWidth="1.8"/>
        {/* Nodes (size decreases with depth) */}
        <circle cx="60" cy="20" r="7" fill="currentColor"/>
        <circle cx="30" cy="52" r="6" fill="currentColor"/>
        <circle cx="90" cy="52" r="6" fill="currentColor"/>
        <circle cx="14" cy="80" r="5" fill="currentColor"/>
        <circle cx="46" cy="80" r="5" fill="currentColor"/>
        <circle cx="74" cy="80" r="5" fill="currentColor"/>
        <circle cx="106" cy="80" r="5" fill="currentColor"/>
    </svg>
)


// =====================================================================
// Card brand logos — simple stylized SVGs (no dependency).
// Each logo sits on a small white/colored "card chip" rectangle so brand colors stay legible against the dark modal background.
// Swap with official brand assets later when needed.
// =====================================================================

export const visaLogo = (
    <svg width="40" height="14" viewBox="0 0 40 14" aria-hidden="true">
        <rect width="40" height="14" rx="2" fill="#1A1F71"/>
        <text
            x="20" y="11"
            textAnchor="middle"
            fontFamily="Arial Black, Arial, sans-serif"
            fontWeight="900"
            fontStyle="italic"
            fontSize="10"
            letterSpacing="0.5"
            fill="#ffffff"
        >
            VISA
        </text>
    </svg>
)

export const mastercardLogo = (
    <svg width="40" height="24" viewBox="0 0 40 24" aria-hidden="true">
        <rect width="40" height="24" rx="2" fill="#ffffff"/>
        <circle cx="15" cy="12" r="7.5" fill="#EB001B" opacity="0.95"/>
        <circle cx="25" cy="12" r="7.5" fill="#F79E1B" opacity="0.9"/>
    </svg>
)

export const amexLogo = (
    <svg width="40" height="14" viewBox="0 0 40 14" aria-hidden="true">
        <rect width="40" height="14" rx="2" fill="#006FCF"/>
        <text
            x="20" y="10"
            textAnchor="middle"
            fontFamily="Arial, sans-serif"
            fontWeight="700"
            fontSize="8"
            letterSpacing="0.8"
            fill="#ffffff"
        >
            AMEX
        </text>
    </svg>
)

// =====================================================================
// Wallet badges — Google Pay / Apple Pay (matches paymentMethod.wallet
// values returned by Stripe: 'google_pay', 'apple_pay').
// =====================================================================

export const googlePayLogo = (
    <svg width="56" height="14" viewBox="0 0 56 14" aria-hidden="true">
        <rect width="56" height="14" rx="2" fill="#ffffff"/>
        {/* Multi-colored G — 4 arcs + blue horizontal bar */}
        <g fill="none" strokeWidth="2">
            <path d="M 2.82 3.82 A 4.5 4.5 0 0 1 9.18 3.82" stroke="#EA4335"/>
            <path d="M 9.18 3.82 A 4.5 4.5 0 0 1 9.18 10.18" stroke="#4285F4"/>
            <path d="M 9.18 10.18 A 4.5 4.5 0 0 1 2.82 10.18" stroke="#34A853"/>
            <path d="M 2.82 10.18 A 4.5 4.5 0 0 1 2.82 3.82" stroke="#FBBC04"/>
        </g>
        <line x1="6" y1="7" x2="10.5" y2="7" stroke="#4285F4" strokeWidth="2"/>
        <text
            x="16" y="10.5"
            fontFamily="Arial, Helvetica, sans-serif"
            fontWeight="500"
            fontSize="9"
            fill="#5F6368"
        >
            Pay
        </text>
    </svg>
)

export const applePayLogo = (
    <svg width="50" height="14" viewBox="0 0 50 14" aria-hidden="true">
        <rect width="50" height="14" rx="2" fill="#000000"/>
        {/* Apple silhouette: two overlapping bulbs + leaf */}
        <ellipse cx="5.5" cy="8" rx="2.3" ry="2.8" fill="#ffffff"/>
        <ellipse cx="7.5" cy="8" rx="2.3" ry="2.8" fill="#ffffff"/>
        <path d="M 7 4.5 Q 7.5 3.5, 8.3 4 Q 8 4.8, 7.2 4.8 Z" fill="#ffffff"/>
        <text
            x="13" y="10.5"
            fontFamily="Arial, Helvetica, sans-serif"
            fontWeight="500"
            fontSize="9"
            fill="#ffffff"
        >
            Pay
        </text>
    </svg>
)

export const discoverLogo = (
    <svg width="60" height="14" viewBox="0 0 60 14" aria-hidden="true">
        <rect width="60" height="14" rx="2" fill="#ffffff"/>
        <text
            x="4" y="11"
            fontFamily="Arial Black, Arial, sans-serif"
            fontWeight="900"
            fontSize="8"
            fill="#000000"
        >
            DISC
        </text>
        <circle cx="27" cy="7" r="3.5" fill="#FF6000"/>
        <text
            x="33" y="11"
            fontFamily="Arial Black, Arial, sans-serif"
            fontWeight="900"
            fontSize="8"
            fill="#000000"
        >
            VER
        </text>
    </svg>
)

// =====================================================================
// Misc icons — checkmark used in the subscription cards feature list.
// =====================================================================

export const checkIcon = (
    <svg className="subscription-card-check" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)